<article class="info-card" (click)="onClick()">
    <div class="icon-container">
        <img [src]="icon" alt="" class="card-icon" />
    </div>
    <h3 class="card-title-1">{{title}}</h3>
</article>